import {makeStyles} from "@material-ui/core/styles";

const StyleQuestionDetail = makeStyles(theme => ({
    checkBox: {
        width: 15
    },
    normalAnswer: {
        color: theme.palette.text.primary
    },
    correctAnswer: {
        color: theme.palette.correct.main
    },
    wrongAnswer: {
        color: theme.palette.wrong.main
    },
    groupQuestion : {
       padding : 10
    },
}));

export default StyleQuestionDetail;